import { Datalayer, OmniaModuleId, OmniaObjectType } from "../omnia"

export function getLayerActivity(create: boolean, layer: Datalayer) {

    return {
        action: create ? "c" : "u",
        resourceId: layer?.datalayerId,
        resourceType: OmniaObjectType.Layer,
        data: {
            TypeId: layer.typeId,
            FieldId: layer.fieldId,
            Name: layer.datalayer?.Name
        }
    }

}
